import type { AssignmentStatusNames } from '~/types';
import { I18n } from '~/common/explicit-exports';

export const ASSIGNMENT_STATUS_ACTION_TEXT: Record<AssignmentStatusNames, string> = {
  overdue: I18n.t('js.learner.card.overdue'),
  not_started: I18n.t('js.learner.card.start_action'),
  needs_grading: I18n.t('js.learner.card.needs_grading'),
  completed: I18n.t('js.learner.card.completed'),
  in_progress: I18n.t('js.learner.card.in_progress'),
  failed: I18n.t('js.learner.card.failed'),
  passed: I18n.t('js.learner.card.passed'),
};

export const DEVELOPMENT_CONTENT_CARD_HEIGHT = 340;
